import { updateDetailsviewChecksum } from "./appblock/detailsviewConfig";
import { updateRecordsviewChecksum } from "./appblock/recordsviewConfig";
import { updateChartBlockChecksum } from "./appblock/chartBlockConfig";
import { updateProgressBarChecksum } from "./appblock/progressBarConfig";
import { updateKanbanChecksum } from "./appblock/kanbanConfig";
import { updateCalendarChecksum } from "./appblock/calendarConfig";
import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";

export const updateApplicationBlockChecksum = (type, blockData, isInit = false) => {
  switch (type) {
    case "recordsview":
      return updateRecordsviewChecksum(blockData, isInit);
    case "detailsview":
    case "activitycard":
      return updateDetailsviewChecksum(blockData, isInit);
    case "chart":
      return updateChartBlockChecksum(blockData, isInit);
    case "progress-bar":
      return updateProgressBarChecksum(blockData, isInit);
    case "kanban":
      return updateKanbanChecksum(blockData, isInit);
    case "calendar":
      return updateCalendarChecksum(blockData, isInit);
    default:
      let storeConfig = { ...blockData };
      if (isInit) {
        updateInitialConfig(storeConfig);
      } else {
        updateModifiedConfig(storeConfig);
      }
      return storeConfig;
  }
};
